// ====================================================================
//  PORTFOLIO CONTENT — edit everything about Sushan's story here.
//  Components read from this file, so the UI stays clean & readable.
// ====================================================================

export const profile = {
  name: 'Sushan Khanal',
  firstName: 'Sushan',
  lastName: 'Khanal',
  role: 'Software Developer',
  // Rotating roles for the hero typewriter effect
  roles: [
    'Software Developer',
    'System Engineer',
    'ASP.NET MVC Specialist',
    'API Developer',
    'Problem Solver',
  ],
  location: 'Osaka, Japan',
  tagline:
    'I design and build reliable software — from robust back-end APIs to polished, accessible interfaces. Currently engineering systems in Osaka, Japan.',
  intro:
    "I'm a software developer with a track record across Nepal and Japan — shipping production APIs at Medipro, full product features at Swivt, and enterprise systems today at Nihon Micro Systems. I care about clean architecture, thoughtful UX, and code that the next developer can actually read.",
  email: 'sushankhanal3@gmail.com',
  linkedin: 'https://www.linkedin.com/in/sushan-k-630273167',
  github: 'https://github.com/',
  resumeUrl: '#',
  available: true,
  stats: [
    { value: '4+', label: 'Years Building Software' },
    { value: '3', label: 'Companies / 2 Countries' },
    { value: '∞', label: 'Cups of Coffee' },
  ],
};

// ----- Experience timeline (most recent first) ---------------------
export const experience = [
  {
    company: '日本マイクロシステムズ（株）',
    companyEn: 'Nihon Micro Systems',
    role: 'System Engineer',
    period: 'Apr 2025 — Present',
    location: 'Osaka, Japan',
    current: true,
    description:
      'Engineering and maintaining enterprise systems for Japanese clients, working across the full stack with a focus on reliability, performance, and long-term maintainability.',
    highlights: [
      'Designing and extending ASP.NET MVC applications used in production.',
      'Collaborating with cross-functional teams across languages and time zones.',
      'Writing clean, well-tested code against complex business requirements.',
    ],
    stack: ['ASP.NET MVC', 'C#', 'SQL Server', 'CSS', 'JavaScript'],
  },
  {
    company: 'Swivt',
    companyEn: 'Swivt',
    role: 'Software Developer',
    period: 'Mar 2022 — Jul 2024',
    location: 'Kathmandu, Nepal',
    description:
      'Built and shipped product features end-to-end for a fast-moving tech company, owning everything from database design to UI polish.',
    highlights: [
      'Delivered full-stack features across web applications.',
      'Worked closely with SQL databases to model and optimize data.',
      'Collaborated with product and design to turn ideas into shippable software.',
    ],
    stack: ['ASP.NET MVC', 'C#', 'SQL', 'CSS', 'JavaScript'],
  },
  {
    company: 'Medipro Computers',
    companyEn: 'Medipro Computers',
    role: 'API Developer',
    period: 'Apr 2021 — Feb 2022',
    location: 'Sundhara, Kathmandu',
    description:
      'Designed and developed REST APIs powering internal tools and client products, with a strong focus on correctness and clear contracts.',
    highlights: [
      'Architected and documented RESTful APIs.',
      'Wrote efficient SQL queries and managed data integrity.',
      'Integrated APIs with front-end applications.',
    ],
    stack: ['C#', 'ASP.NET', 'SQL', 'REST APIs'],
  },
];

// ----- Skill groups -------------------------------------------------
export const skills = [
  {
    category: 'Backend',
    icon: 'server',
    items: ['C#', 'ASP.NET MVC', 'ASP.NET', 'REST APIs', '.NET'],
  },
  {
    category: 'Database',
    icon: 'database',
    items: ['SQL', 'SQL Server', 'T-SQL', 'Database Design'],
  },
  {
    category: 'Frontend',
    icon: 'layout',
    items: ['CSS', 'JavaScript', 'HTML5', 'Responsive Design'],
  },
  {
    category: 'Practices',
    icon: 'tools',
    items: ['System Design', 'Troubleshooting', 'Code Review', 'Git'],
  },
];

// ----- Project showcase ---------------------------------------------
// Replace demo links & descriptions with real repos / live demos later.
export const projects = [
  {
    title: 'Enterprise MVC Platform',
    blurb:
      'A scalable ASP.NET MVC application built for production use at Nihon Micro Systems — modular architecture, robust data access, and a clean admin UX.',
    tags: ['ASP.NET MVC', 'C#', 'SQL Server'],
    accent: 'violet',
    link: '#',
  },
  {
    title: 'Product Feature Suite',
    blurb:
      'End-to-end feature development at Swivt — from SQL schema design to polished front-end delivery, shipped to real users.',
    tags: ['C#', 'SQL', 'JavaScript'],
    accent: 'cyan',
    link: '#',
  },
  {
    title: 'REST API Framework',
    blurb:
      'Designed and documented a set of RESTful services at Medipro Computers powering client products, with a focus on clear contracts and performance.',
    tags: ['C#', 'ASP.NET', 'REST'],
    accent: 'amber',
    link: '#',
  },
  {
    title: 'Data-Driven Dashboards',
    blurb:
      'Internal dashboards turning complex SQL datasets into clear, actionable views for business stakeholders.',
    tags: ['SQL', 'CSS', 'JavaScript'],
    accent: 'emerald',
    link: '#',
  },
];

// ----- Education ----------------------------------------------------
export const education = [
  {
    school: 'Kathmandu College of Technology',
    degree: "Bachelor's degree",
    field: 'Computer Science',
    period: '2016 — 2020',
  },
];

// ----- Navigation ---------------------------------------------------
export const navLinks = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'skills', label: 'Skills' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Projects' },
  { id: 'contact', label: 'Contact' },
];
